module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-38-min.15694bbf.jpg";